﻿import { Accessor, createRenderEffect, Setter, Signal } from "solid-js";

declare module 'solid-js' {
    namespace JSX {
        interface Directives {
            visibleWith: HTMLElement
        }
    }
}

declare global {
    interface Window {
        visibleWith: (options?: HTMLElement) => void;
    }
}

window.visibleWith = window.visibleWith ?? ((el: HTMLElement, target: () => HTMLElement) => {
    el.style.transition = 'opacity linear 0.5s';
    el.style.opacity = '0.1';

    target()?.addEventListener('mouseenter', ev => {
        el.style.opacity = '1';
    });

    target().addEventListener('mouseleave', ev => {
        el.style.opacity = '0.1';
    });
});
